import { call, put, takeLatest } from 'redux-saga/effects';
import {
	checkStatus,
	sendRequest,
	sendRequestSuccess,
	sendRequestFailure,
	updateStatus
} from '../actions/actions';

import { mainApi } from '../api/mainApi';

function* handleInstallation( body ) {
	try {
		const apiData = yield call(
			mainApi(
				'https://wpwizardapi.siteground.com/installation',
				'POST',
				body.payload,
				{
					'Accept': 'application/json',
					'Content-Type': 'application/json',
				}
			)
		);

		const data = yield call(
			mainApi(
				window.wizardData.installation_endpoint,
				'POST',
				apiData,
				{
					'Accept': 'application/json',
					'Content-Type': 'application/x-www-form-urlencoded',
					'X-WP-Nonce' : window.wizardData.wp_nonce
				},
				true
			)
		);
	} catch (e) {
		console.error(`${e}`, e);
		yield put(sendRequestFailure(e));
	}
}

function* handleStatusCheck() {
	try {		
		const data = yield call(
			mainApi(
				window.wizardData.status_endpoint + new Date().getTime(),
				'GET',
				{
					'Accept': 'application/json',
					'Content-Type': 'application/json',
				}
			)
		);

		yield put(updateStatus(data));
	} catch (e) {
		console.error(`${e}`, e);
	}
}

function* installation(): any {
	yield takeLatest(checkStatus, handleStatusCheck);
	yield takeLatest(sendRequest, handleInstallation);
}

export default installation;
